var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTollGate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Subscription",
    transform: "translate(-85 -590)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147995",
    "data-name": "Rectangle 147995",
    width: 47,
    height: 46,
    rx: 10,
    transform: "translate(85 590)",
    fill: "#1b1c1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "torii-gate-solid-svgrepo-com",
    d: "M2.938,4.969V6.121l.2.2L5.678,8.643l.2.159H6.79v1.906H5.519v1.271H6.79v6.99H8.061v-6.99h6.355v6.99h1.271v-6.99h1.271V10.708H15.686V8.8h.874l.2-.159L19.3,6.319l.2-.2V4.969l-.774.179a47.343,47.343,0,0,1-7.487.477,48.235,48.235,0,0,1-7.526-.477ZM5.38,6.617a57.84,57.84,0,0,0,5.858.278,57.828,57.828,0,0,0,5.818-.278l-.993.913H6.373ZM8.061,8.8H9.967v1.906H8.061Zm4.448,0h1.906v1.906H12.509Z",
    transform: "translate(97.062 601.031)",
    fill: "#fdfdfd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTollGate);
export default __webpack_public_path__ + "static/media/toll_gate.f16922965a0668a770373c7cc67a3504.svg";
export { ForwardRef as ReactComponent };